$(document).ready(function(){
    trackProfilesRowContentToggle();
    trackFaqToggler();
});

$(window).on('resize', function(){
    if($(window).width() <= 678){
        $('[data-profile-wrapper].active').removeClass('active');
    }
});

function trackProfilesRowContentToggle(){
    $(`[data-profile-toggler]`).on('click touch', function(){
        const $wrapper = $(this).closest('[data-profile-wrapper]');
        $wrapper.toggleClass('active', !$wrapper.hasClass('active'));
    });
}

function trackFaqToggler(){
    $('[data-toggler-target]').on('click touch', function(){
        const target = $(this).attr('data-toggler-target');
        const already_toggled = $(this).hasClass('toggled');

        $('[data-toggler-target]').removeClass('toggled');
        $('[data-target-id]').addClass('dynamic-faq__content--hidden');

        if (!already_toggled){
            $(this).addClass('toggled');

            const $target = $(`[data-target-id="${target}"]`);
            $target.removeClass('dynamic-faq__content--hidden');
            if ($target.is('[data-no-scroll]')){
                return;
            }
            $target.get(0).scrollIntoView({behavior: 'smooth'});
        }
    });
}
